import { App, ConfigProvider } from 'antd'
import React from 'react'
import ReactDOM from 'react-dom/client'
import styled, { createGlobalStyle } from 'styled-components'
import Home from './Home'
import AuthProvider from './common/AuthProvider'
import './index.css'

const GlobalStyle = createGlobalStyle`
    #root {
        width: 100%;
    }
`

const StyledApp = styled(App)`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
`

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
    <React.StrictMode>
        <ConfigProvider>
            <GlobalStyle />
            <StyledApp>
                <AuthProvider>
                    <Home />
                </AuthProvider>
            </StyledApp>
        </ConfigProvider>
    </React.StrictMode>
)
